(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/syndicate-term-dialog-helper.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/syndicate-term-dialog-helper.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.syndicate.core.showSyndicateTermsDialog = function(successCb) {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
      svs.syndicate.rules_and_terms.checkAndShowSyndicateTermsDialog(successCb);
    } else {
      successCb();
    }
  };
})(Backbone, _, svs);


 })(window);